import axios from 'axios';
import { SnackbarProvider } from 'notistack';
import Main from './Main.js';

axios.interceptors.request.use(function (config) {
  const token = document.cookie.split(";").find((item) => item.trim().startsWith("token="))
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
}, (error) => {
  return Promise.reject(error);
});

function App() {
  return (
    <SnackbarProvider maxSnack={5} dense={false}>
      <Main />
    </SnackbarProvider>
  );

}

export default App;
